import { jsx as _jsx } from "react/jsx-runtime";
import RouteGenerator from './routes/RouteGenerator';
import { Route, Routes } from 'react-router-dom';
import './styles.scss';
import Web_Routes from './routes/routes';
var App = function () {
    return (_jsx("div", { className: 'App', children: _jsx(Routes, { children: Web_Routes.map(function (route) {
                //console.log(route);
                return _jsx(Route, { path: route.PATH, element: _jsx(RouteGenerator, { routes: route.SUB_ROUTES, layout: route.LAYOUT }) }, route.PATH);
            }) }) }));
};
export default App;
